import { memo } from 'react';
import { createPortal } from 'react-dom';
import {
  ToastContainer as ToastifyToastContainer,
  type ToastContainerProps as ToastifyToastContainerProps,
} from 'react-toastify';

import { TOAST_ROOT_ID } from '../../meta/dialogs-provider/constants';
import { type CloseButtonProps, ToastCloseButton } from './close-button/ToastCloseButton';

const closeButton = (props: CloseButtonProps) => <ToastCloseButton {...props} />;

/**
 * This is a wrapper around ToastContainer from react-toastify to set our default props.
 */
export const ToastContainerBase = (props: ToastifyToastContainerProps) => {
  // Init the modal root at the bottom of the body.
  if (!document.getElementById(TOAST_ROOT_ID)) {
    const modalRoot = document.createElement('div');
    modalRoot.setAttribute('id', TOAST_ROOT_ID);
    document.body.appendChild(modalRoot);
  }

  return createPortal(
    <ToastifyToastContainer
      closeButton={closeButton}
      closeOnClick
      icon={false}
      theme="colored"
      {...props}
    />,
    document.getElementById(TOAST_ROOT_ID),
  );
};

ToastContainerBase.displayName = 'ToastContainer';

export const ToastContainer = memo(ToastContainerBase);
